import React from 'react';

import PropTypes from 'prop-types';

import { URL_IMAGES_I } from 'constants/UrlConstants';

import clsx from 'clsx';

import styles from './AppButton.module.css';

export const AppButton = (props) => {
    const getImgLink = (props) => {
        if (props.variant === 'apple') {
            return props.esLang ? 'store-apple-inverted-es.svg' : props.isInverted ? 'store-apple-inverted.svg' : 'store-apple.svg';
        } else if (props.variant === 'google') {
            return props.esLang ? 'store-google-inverted-es.svg' : props.isInverted ? 'store-google-inverted.svg' : 'store-google.svg';
        } else if (props.variant === 'huawei') {
            return props.isInverted ? 'store-huawei-inverted.svg' : 'store-huawei.svg';
        }
    };

    const containerClasses = clsx(styles.container, {
        [styles.esLang]: props.esLang,
        [styles.isInverted]: props.isInverted,
    });

    const imgClasses = clsx(styles.appImg, {
        [styles.esLang]: props.esLang,
    });

    return (
        <a href={props.href} rel="noreferrer" target="_blank" aria-label={props.areaLabel} tabIndex={'0'} className={containerClasses}>
            <img src={`${URL_IMAGES_I}/${getImgLink(props)}`} loading="lazy" decoding="async" alt={props.areaLabel} className={imgClasses} />
        </a>
    );
};

AppButton.propTypes = {
    href: PropTypes.string,
    variant: PropTypes.oneOf(['apple', 'google', 'huawei']),
    areaLabel: PropTypes.oneOf(['App Store', 'Google Play', 'AppGallery']),
    isInverted: PropTypes.bool,
    esLang: PropTypes.bool,
};
